import { GiProcessor } from "react-icons/gi";
import { useTranslation } from "react-i18next";

import './contact.scss'

type From = { name: string, mail: string, text: string }

type ContactProps = {
  contactForm: From
  setContactForm: (value: From) => void
}

function Contact(props: Readonly<ContactProps>) {
  const { t, i18n } = useTranslation()

  const handleForm = (type: string, value: string) => {
    props.setContactForm({...props.contactForm, [type]: value})
  }

  const checkValid = () => {
    const checkNameMail = props.contactForm.name.length === 0 || props.contactForm.text.length === 0
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const checkMail = regex.test(props.contactForm.mail)
    return !checkMail || checkNameMail
  }

  return (
    <div className='page-contact'>
      <div className='contact-content'>
        <div className='content-header'>
          <div className='header-title' >
            <div>{t('contact.title')}</div>
            <div className={`title-mid ${i18n.language === 'de' ? 'title-midColor' : ''}`}>{t('contact.title1')}</div>
            <div className={`title-mid ${i18n.language === 'en' ? 'title-midColor' : ''}`}>{t('contact.title2')}</div>
          </div>
          <div className='header-subTitle' >{t('contact.subtitle')}</div>
        </div>
       <div className='content-card'>
        <div className='card-bg'></div>
        <div className='card-bg card-bg2'></div>
        <div className='card-content'>
          <div className='content-container left'>
            <GiProcessor />
          </div>
          <div className='content-line'/>
          <div className='content-container'>
            <div className="container-form">
              <input onChange={(e) => {handleForm('name', e.target.value)}} value={props.contactForm.name} placeholder={t('contact.form.inputNameplaceholder')}></input>
              <input onChange={(e) => {handleForm('mail', e.target.value)}} value={props.contactForm.mail}  placeholder={t('contact.form.inputMailplaceholder')}></input>
              <textarea onChange={(e) => {handleForm('text', e.target.value)}} value={props.contactForm.text} rows={14} placeholder={t('contact.form.inputTextplaceholder')}></textarea>
              <button
                disabled={checkValid()}
                className={checkValid() ? 'disabled' : ''}
              >
                {t('contact.form.enterButton')}
              </button>
            </div>
          </div>
        </div>
       </div>
      </div>
    </div>
  )
}

export default Contact
